// src/App.jsx

import React, { useEffect } from 'react';
import { BrowserRouter, Routes, Route, Navigate, useNavigate } from 'react-router-dom';
import { GroupProvider } from './context/GroupContext';
import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

import HomePage from './pages/HomePage';
import GroupSearchAndJoin from './pages/GroupSearchAndJoin';
import SuccessPage from './pages/SuccessPage';
import CancelPage from './pages/CancelPage';
import ReviewPage from './pages/ReviewPage';
import CreateGroup from './pages/admin/CreateGroup';
import Login from './pages/Login';
import RegisterPage from './pages/RegisterPage';
import AdminRoute from './components/AdminRoute';
import ProtectedRoute from './components/ProtectedRoute';
import Header from './components/Header';
import SessionTimer from './components/SessionTimer';
import ViewGroup from './pages/admin/ViewGroup';
import EditGroup from './pages/admin/EditGroup';
import AdminGroupsPage from './pages/admin/AdminGroupsPage';
import AdminUsersPage from './pages/admin/AdminUsersPage';
import AdminSupplierPage from './pages/admin/AdminSupplierPage';
import ForgotPassword from './pages/ForgotPassword';
import ResetPassword from './pages/ResetPassword';
import PendingAdminApprovals from './pages/admin/PendingAdminApprovals';
// import LandingPage from './pages/LandingPage';
import InvitePage from './pages/InvitePage';
import JoinGroup from './pages/JoinGroup';
import AcceptInvite from './pages/Accept-invite';
import HelpSupport from './pages/HelpSupport';
import MyOrders from './pages/MyOrders';
import SupplierOrders from './pages/SupplierOrders';


// /cart is no longer a page: the cart opens in the header drawer. A direct visit or refresh goes back to
// the previous page when the browser has one, otherwise to the home page.
function CartRedirect() {
  const navigate = useNavigate();
  useEffect(() => {
    if (window.history.state && window.history.state.idx > 0) navigate(-1);
    else navigate('/', { replace: true });
  }, [navigate]);
  return null;
}

function AppLayout({ children }) {
  return (
    <div>
      <Header />
      <SessionTimer />
      <main>{children}</main>
    </div>
  );
}

export default function App() {
  return (
    <BrowserRouter
      future={{
        v7_startTransition: true,
        v7_relativeSplatPath: true,
      }}
    >
      <GroupProvider>
        <AppLayout>
          <Routes>
            {/* <Route path="/" element={<LandingPage />} /> */}
            <Route path="/" element={<HomePage />} />
            <Route path="/home" element={<HomePage />} />
            <Route path="/success" element={<SuccessPage />} />
            <Route path="/cancel" element={<CancelPage />} />
            <Route path="/review" element={<ReviewPage />} />
            <Route path="/unauthorized" element={<div>You are not authorized to view this page.</div>} />
            {/* Dashboard and Manage Groups are the same page now; keep /admin working as a redirect */}
            <Route path="/admin" element={<Navigate to="/admin/groups" replace />} />
            <Route path="/admin/suppliers" element={<AdminRoute allowedRoles={['superadmin', 'supplieradmin']}><AdminSupplierPage /></AdminRoute>} />
            <Route path="/admin/supplier-orders" element={<AdminRoute allowedRoles={['supplieradmin']} ><SupplierOrders /></AdminRoute>} />
            <Route path="/admin/pending-admins" element={<AdminRoute allowedRoles={['superadmin']}><PendingAdminApprovals /></AdminRoute>} />
            <Route path="/admin/create-group" element={<AdminRoute allowedRoles={['supplieradmin']}><CreateGroup /></AdminRoute>} />
            <Route path="/admin/groups" element={<AdminRoute allowedRoles={['supplieradmin', 'member']}><AdminGroupsPage /></AdminRoute>} />
            <Route path="/admin/users" element={<AdminRoute allowedRoles={['supplieradmin']}><AdminUsersPage /></AdminRoute>} />
            <Route path="/admin/groups/view/:id" element={<AdminRoute allowedRoles={['supplieradmin', 'member']}><ViewGroup /></AdminRoute>} />
            <Route path="/admin/groups/edit/:id" element={<AdminRoute allowedRoles={['supplieradmin', 'member']}><EditGroup /></AdminRoute>} />


            <Route path="/my-orders" element={<ProtectedRoute><MyOrders /></ProtectedRoute>} />
            <Route path="/help" element={<HelpSupport />} />
            <Route path="/cart" element={<CartRedirect />} />
            <Route path="/login" element={<Login />} />
            <Route path="/register" element={localStorage.getItem('user') ? <Navigate to="/home" replace /> : <RegisterPage />} />
            <Route path="/invite" element={<InvitePage />} />
            <Route path="/join-group" element={<JoinGroup />} />
            <Route path="/Accept-invite" element={<AcceptInvite />} />

            <Route path="/GroupSearchAndJoin" element={<GroupSearchAndJoin />} />
            <Route path="/forgot-password" element={localStorage.getItem('user') ? <Navigate to="/home" replace /> : <ForgotPassword />} />
            <Route path="/reset-password/:token" element={<ResetPassword />} />
          </Routes>
        </AppLayout>

        {/* Global Toast Container - only one needed */}
        <ToastContainer
          position="top-right"
          autoClose={3000}
          theme="colored"

        />
      </GroupProvider>
    </BrowserRouter>
  );
}
